import { cn } from '../../lib/cn';

/**
 * "SEND RECEIPT" — one control on every screen that records a payment by hand:
 * an invoice's Record payment, a bank deposit, the strong-match batch and bulk
 * Record payment. It starts TICKED (Jesse, 2026-10-05: *"a confirmation that
 * has a pre-checked 'Send receipt' checkbox"*): a client who paid should hear
 * so, and unticking is the deliberate act.
 */
export function SendReceiptField({
  checked,
  onChange,
  many = false,
  disabled,
  className,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Several payments at once — "receipts", one per client. */
  many?: boolean;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <label
      className={cn(
        'flex cursor-pointer items-start gap-3 rounded-lg border border-grey-200 px-3 py-2.5',
        disabled && 'cursor-not-allowed opacity-60',
        className,
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 cursor-pointer rounded border-grey-300 accent-accent"
      />
      <span className="min-w-0">
        <span className="block text-body-sm font-semibold text-secondary">
          {many ? 'Send receipts' : 'Send receipt'}
        </span>
        <span className="block text-caption text-grey-600">
          {many
            ? 'Emails each client a thank-you receipt for their payment, to the billing contacts on the invoice.'
            : 'Emails the client a thank-you receipt for this payment, to the billing contacts on the invoice.'}
        </span>
      </span>
    </label>
  );
}

export interface ReceiptOutcome {
  status: string;
  to: string | null;
}

export const receiptWent = (r: ReceiptOutcome | null | undefined) => r?.status === 'sent' || r?.status === 'filed';

/** What happened to the receipt, as a clause for the toast. */
export function receiptClause(r: ReceiptOutcome | null | undefined): string {
  if (!r) return '';
  if (r.status === 'sent') return ` · receipt sent to ${r.to ?? 'the client'}`;
  if (r.status === 'filed') return ' · receipt written to .mail/ (development — not transmitted)';
  if (r.status === 'skipped') return ' · no receipt sent — the client has no billing email';
  return ' · the receipt did not go — use Re-send receipt on the invoice';
}
